var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-chart',{attrs:{"path-option":_vm.computeChartOption,"height":"250px","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }